import { Autocomplete, FormControl, TextField } from '@mui/material';
import type { IRow } from '../types/TableRows';

type FilterField = 'accountName' | 'clientName' | 'breakId';

interface FiltersProps {
  filters: Record<FilterField, string>;
  filterLabels: Record<FilterField, string>;
  getUniqueValues: (field: keyof IRow) => string[];
  handleFilterChange: (field: FilterField) => (value: string) => void;
}

const FiltersFront = ({ filters, filterLabels, getUniqueValues, handleFilterChange }: FiltersProps) => (
  <div className="flex flex-col justify-between gap-5 lg:flex-col xl:flex-row">
    {(Object.keys(filters) as FilterField[]).map((field) => {
      const options = getUniqueValues(field);
      const value = filters[field];

      return (
        <FormControl key={field} className="xs:w-96 md:w-60 2xl:w-96">
          <Autocomplete
            freeSolo
            disablePortal
            id={`autocomplete-${field}`}
            options={[...options]}
            value={value}
            onChange={(_, newValue) => handleFilterChange(field)(newValue!)}
            renderInput={(params) => <TextField {...params} label={filterLabels[field]} />}
          />
        </FormControl>
      );
    })}
  </div>
);

export default FiltersFront;
